import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';
import {
  required,
  email,
  lessThanValue,
  validateReceiverEmail,
  allowedNumberValuesRange
} from 'apex-web/lib/helpers/formValidations';
import SendAddressContainer from '../SendAddress/SendAddressContainer';
import VerificationRequiredContainer from 'apex-web/lib/components/VerificationRequired/VerificationRequiredContainer';
import APNumberInput from 'apex-web/lib/components/common/APNumberInput';
import APInput from 'apex-web/lib/components/common/APInput';
import APButton from 'apex-web/lib/components/common/APButton';
import APLabelWithText from 'apex-web/lib/components/common/APLabelWithText';
import { product as ProductPropTypes } from 'apex-web/lib/propTypes/sendReceiveComponent';
import './SendForm.css';
import config from 'apex-web/lib/config';

const bemClasses = getBEMClasses('send-form');

const allowedAmountValuesRange = allowedNumberValuesRange(
  '0',
  '79228162514264337593543950335'
);

class SendForm extends React.Component {
  lessThanBalance = value => {
    const { balance } = this.props;
    if (balance === 0) return this.context.t('0 balance available');
    return lessThanValue(balance, value);
  };

  checkUserEmail = value => {
    const { userEmail } = this.props;
    return validateReceiverEmail(value, userEmail);
  };

  // componentWillReceiveProps(nextProps) {
  //   const nextAmount = nextProps.Amount;
  //   const Amount = this.props.Amount;
  //   // if at least one of the form values changed
  //   if ( Amount !== nextAmount ) {
  //     this.props.onChange( nextAmount );
  //   }
  // }

  render() {
    const {
      product: {
        ProductFullName: name,
        ProductSymbol: symbol,
        DecimalPlaces: decimalPlaces
      },
      handleSubmit,
      invalid,
      submitting,
      onSubmit,
      useExternalAddress,
      toggleUseExternalAddress,
      balance,
      product,
      fee,
      total,
      showDetails,
      disableWithdraw,
      verificationOnClick,
      allowTransfer,
      withdrawError,
      verificationLevelConfig,
      showWithdrawLimitWarningMessage
    } = this.props;
    return (
      <form onSubmit={handleSubmit(onSubmit)} className={bemClasses()}>
        <section className={bemClasses('send-to')}>
          {!showWithdrawLimitWarningMessage && (
            <header className={bemClasses('source')}>
              <div className={bemClasses('source-item-with-border')}>
                <div
                  className={bemClasses('source-item', {
                    selected: useExternalAddress
                  })}
                  onClick={() => {
                    !useExternalAddress && toggleUseExternalAddress();
                  }}>
                  {this.context.t('External Wallet')}
                </div>
              </div>
              {allowTransfer && (
                <div
                  className={bemClasses('source-item', {
                    selected: !useExternalAddress
                  })}
                  onClick={() => {
                    useExternalAddress && toggleUseExternalAddress();
                  }}>
                  {this.context.t('To Email Address')}
                </div>
              )}
            </header>
          )}
        </section>

        {disableWithdraw ? (
          <VerificationRequiredContainer
            disabled={disableWithdraw}
            onClick={verificationOnClick}
          />
        ) : showWithdrawLimitWarningMessage ? (
          <div>
            Withdraws are disabled for your verification level. Please contact
            the exchange administrator.
          </div>
        ) : (
          <React.Fragment>
            {useExternalAddress ? (
              <SendAddressContainer
                product={product}
                balance={balance}
                verificationLevelConfig={verificationLevelConfig}
              />
            ) : (
              <React.Fragment>
                <p className={bemClasses('label-text')}>
                  {this.context.t('Recipient’s Email Address')}
                </p>

                <APInput
                  name="ReceiverUsername"
                  customClass={bemClasses()}
                  validate={[required, email, this.checkUserEmail]}
                />
              </React.Fragment>
            )}

            {(!withdrawError || !useExternalAddress) && (
              <React.Fragment>
                <label className={bemClasses('label-text')}>
                  {this.context.t('Amount of {name} to Send', { name })}
                </label>

                <section className={bemClasses('amounts')}>
                  <APNumberInput
                    name="Amount"
                    customClass={bemClasses()}
                    labelInInput={symbol}
                    decimalPlaces={decimalPlaces}
                    allowBigNumber
                    validate={[
                      required,
                      allowedAmountValuesRange,
                      this.lessThanBalance
                    ]}
                  />
                </section>
              </React.Fragment>
            )}

            {!showDetails && (
              <section className={bemClasses('info-items')}>
                <APLabelWithText
                  label={this.context.t('Current Balance:')}
                  text={balance}
                  customClass={bemClasses()}
                />
                <APLabelWithText
                  label={this.context.t('Transaction Fee:')}
                  text={fee !== undefined ? fee : '-'}
                  customClass={bemClasses()}
                />
                <APLabelWithText
                  label={this.context.t('Total Amount:')}
                  text={total !== undefined ? `${total} ${symbol}` : '-'}
                  customClass={bemClasses()}
                />
              </section>
            )}

            {!useExternalAddress && (
              <section className={bemClasses('note')}>
                <p className={bemClasses('label-text')}>
                  {this.context.t('Add a Note ')}
                  <em>{this.context.t('(Optional)')}</em>
                </p>

                <APInput name="Notes" rows={3} customClass={bemClasses()} />
              </section>
            )}

            {(!withdrawError || !useExternalAddress) && (
              <APButton
                type="submit"
                customClass={bemClasses()}
                styleName="additive"
                disabled={invalid || submitting}>
                {this.context.t('Send')} {name}
              </APButton>
            )}
          </React.Fragment>
        )}
      </form>
    );
  }
}

SendForm.propTypes = {
  product: ProductPropTypes.isRequired,
  onSubmit: PropTypes.func.isRequired,
  useExternalAddress: PropTypes.bool.isRequired,
  balance: PropTypes.number.isRequired,
  toggleUseExternalAddress: PropTypes.func.isRequired,
  allowTransfer: PropTypes.bool.isRequired,
  fee: PropTypes.number,
  total: PropTypes.number,
  disableWithdraw: PropTypes.bool,
  verificationOnClick: PropTypes.func
};

SendForm.contextTypes = {
  t: PropTypes.func.isRequired
};

export default SendForm;
